/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
}

export type Query = {
  __typename?: 'Query'
  _allPagesMeta?: Maybe<ListMetadata>
  _allPostsMeta?: Maybe<ListMetadata>
  _allUsersMeta?: Maybe<ListMetadata>
  allPages?: Maybe<Array<Maybe<Page>>>
  allPosts?: Maybe<Array<Maybe<Post>>>
  allUsers?: Maybe<Array<Maybe<User>>>
  Page?: Maybe<Page>
  Post?: Maybe<Post>
  User?: Maybe<User>
}

export type Query_AllPagesMetaArgs = {
  filter?: InputMaybe<PageFilter>
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
}

export type Query_AllPostsMetaArgs = {
  filter?: InputMaybe<PostFilter>
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
}

export type Query_AllUsersMetaArgs = {
  filter?: InputMaybe<UserFilter>
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
}

export type QueryAllPagesArgs = {
  filter?: InputMaybe<PageFilter>
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
  sortField?: InputMaybe<Scalars['String']>
  sortOrder?: InputMaybe<Scalars['String']>
}

export type QueryAllPostsArgs = {
  filter?: InputMaybe<PostFilter>
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
  sortField?: InputMaybe<Scalars['String']>
  sortOrder?: InputMaybe<Scalars['String']>
}

export type QueryAllUsersArgs = {
  filter?: InputMaybe<UserFilter>
  page?: InputMaybe<Scalars['Int']>
  perPage?: InputMaybe<Scalars['Int']>
  sortField?: InputMaybe<Scalars['String']>
  sortOrder?: InputMaybe<Scalars['String']>
}

export type QueryPageArgs = {
  id: Scalars['ID']
}

export type QueryPostArgs = {
  id: Scalars['ID']
}

export type QueryUserArgs = {
  id: Scalars['ID']
}

export type PageFilter = {
  blocks?: InputMaybe<Scalars['JSON']>
  blocks_neq?: InputMaybe<Scalars['JSON']>
  id?: InputMaybe<Scalars['ID']>
  id_neq?: InputMaybe<Scalars['ID']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  q?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
  slug_neq?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  title_neq?: InputMaybe<Scalars['String']>
}

export type ListMetadata = {
  __typename?: 'ListMetadata'
  count?: Maybe<Scalars['Int']>
}

export type PostFilter = {
  id?: InputMaybe<Scalars['ID']>
  id_neq?: InputMaybe<Scalars['ID']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  q?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  title_neq?: InputMaybe<Scalars['String']>
  user_id?: InputMaybe<Scalars['ID']>
  user_id_neq?: InputMaybe<Scalars['ID']>
}

export type UserFilter = {
  id?: InputMaybe<Scalars['ID']>
  id_neq?: InputMaybe<Scalars['ID']>
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  name?: InputMaybe<Scalars['String']>
  name_neq?: InputMaybe<Scalars['String']>
  q?: InputMaybe<Scalars['String']>
}

export type Page = {
  __typename?: 'Page'
  blocks: Scalars['JSON']
  id: Scalars['ID']
  slug: Scalars['String']
  title: Scalars['String']
}

export type Post = {
  __typename?: 'Post'
  id: Scalars['ID']
  title: Scalars['String']
  User?: Maybe<User>
  user_id: Scalars['ID']
}

export type User = {
  __typename?: 'User'
  id: Scalars['ID']
  name: Scalars['String']
  Posts?: Maybe<Array<Maybe<Post>>>
}

export type Mutation = {
  __typename?: 'Mutation'
  createManyPage?: Maybe<Array<Maybe<Page>>>
  createManyPost?: Maybe<Array<Maybe<Post>>>
  createManyUser?: Maybe<Array<Maybe<User>>>
  createPage?: Maybe<Page>
  createPost?: Maybe<Post>
  createUser?: Maybe<User>
  removePage?: Maybe<Page>
  removePost?: Maybe<Post>
  removeUser?: Maybe<User>
  updatePage?: Maybe<Page>
  updatePost?: Maybe<Post>
  updateUser?: Maybe<User>
}

export type MutationCreateManyPageArgs = {
  data?: InputMaybe<Array<InputMaybe<PageInput>>>
}

export type MutationCreateManyPostArgs = {
  data?: InputMaybe<Array<InputMaybe<PostInput>>>
}

export type MutationCreateManyUserArgs = {
  data?: InputMaybe<Array<InputMaybe<UserInput>>>
}

export type MutationCreatePageArgs = {
  blocks: Scalars['JSON']
  slug: Scalars['String']
  title: Scalars['String']
}

export type MutationCreatePostArgs = {
  title: Scalars['String']
  user_id: Scalars['ID']
}

export type MutationCreateUserArgs = {
  name: Scalars['String']
}

export type MutationRemovePageArgs = {
  id: Scalars['ID']
}

export type MutationRemovePostArgs = {
  id: Scalars['ID']
}

export type MutationRemoveUserArgs = {
  id: Scalars['ID']
}

export type MutationUpdatePageArgs = {
  blocks?: InputMaybe<Scalars['JSON']>
  id: Scalars['ID']
  slug?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type MutationUpdatePostArgs = {
  id: Scalars['ID']
  title?: InputMaybe<Scalars['String']>
  user_id?: InputMaybe<Scalars['ID']>
}

export type MutationUpdateUserArgs = {
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}

export type PageInput = {
  blocks: Scalars['JSON']
  slug: Scalars['String']
  title: Scalars['String']
}

export type PostInput = {
  title: Scalars['String']
  user_id: Scalars['ID']
}

export type UserInput = {
  name: Scalars['String']
}

export type UserFragmentFragment = {
  __typename?: 'User'
  id: string
  name: string
}

export type AuthRefreshTokenMutationVariables = Exact<{ [key: string]: never }>

export type AuthRefreshTokenMutation = { __typename: 'Mutation' }

export type AuthLoginQueryVariables = Exact<{ [key: string]: never }>

export type AuthLoginQuery = { __typename: 'Query' }

export type ExampleUpdateUserMutationVariables = Exact<{
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
}>

export type ExampleUpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser?: { __typename?: 'User'; id: string; name: string } | null
}

export type ExampleUserByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type ExampleUserByIdQuery = {
  __typename?: 'Query'
  User?: { __typename?: 'User'; id: string; name: string } | null
}

export const UserFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragmentFragment, unknown>
export const AuthRefreshTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AuthRefreshToken' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthRefreshTokenMutation,
  AuthRefreshTokenMutationVariables
>
export const AuthLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AuthLogin' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthLoginQuery, AuthLoginQueryVariables>
export const ExampleUpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExampleUpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ExampleUpdateUserMutation,
  ExampleUpdateUserMutationVariables
>
export const ExampleUserByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExampleUserById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'User' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ExampleUserByIdQuery,
  ExampleUserByIdQueryVariables
>
